export default __webpack_public_path__ + "static/media/newsfeedWhite.5d2d6c96.svg";